import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import { useAuthStore } from '@/store/modules/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForcePasswordReset',
  setup(__props) {

const authStore = useAuthStore()

const newPassword = ref('')
const confirmNewPassword = ref('')
const showNewPassword = ref(false)
const resetValid = ref(false)
const resetting = ref(false)
const resetError = ref('')

// Dialog; oturum açık VE (login akışı bayrağı VEYA Firestore'daki kalıcı bayrak)
// true olduğunda görünür. Firestore bayrağı sayfa yenilense bile korunur.
const show = computed(() =>
    authStore.isAuthenticated &&
    (authStore.mustResetPassword || authStore.user?.mustResetPassword === true)
)

const passwordRules = [
  (v: string) => !!v || 'Şifre gereklidir',
  (v: string) => v.length >= 6 || 'Şifre en az 6 karakter olmalıdır'
]

const confirmPasswordRules = [
  (v: string) => !!v || 'Şifre tekrarı gereklidir',
  (v: string) => v === newPassword.value || 'Şifreler eşleşmiyor'
]

const handleSubmit = async () => {
  if (!resetValid.value || resetting.value) return

  resetting.value = true
  resetError.value = ''
  try {
    await authStore.completePasswordReset(newPassword.value)
    // Başarılı: bayraklar temizlendi, dialog otomatik kapanır
    newPassword.value = ''
    confirmNewPassword.value = ''
  } catch (error: any) {
    console.error('Şifre belirleme hatası:', error)
    resetError.value = error?.message || 'Şifre belirlenirken bir hata oluştu. Lütfen tekrar deneyin.'
  } finally {
    resetting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": show.value,
    persistent: "",
    "no-click-animation": "",
    scrim: true,
    "max-width": "480",
    "retain-focus": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center pa-4 bg-warning text-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-lock-alert",
                class: "mr-2"
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" Şifrenizi Belirleyin "))
            ]),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                type: "warning",
                variant: "tonal",
                density: "comfortable",
                class: "mb-4"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "font-weight-bold mb-1" }, "Geçici şifreyle giriş yaptınız", -1),
                  _createElementVNode("div", { class: "text-body-2" }, " Güvenliğiniz için devam etmeden önce yeni (kalıcı) bir şifre belirlemeniz gerekiyor. Şifrenizi belirlemeden bu pencereyi kapatamaz veya uygulamayı kullanamazsınız. ", -1)
                ])),
                _: 1,
                __: [5]
              }),
              _createVNode(_component_v_form, {
                ref: "resetForm",
                modelValue: resetValid.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((resetValid).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: newPassword.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
                    label: "Yeni Şifre",
                    type: showNewPassword.value ? 'text' : 'password',
                    variant: "outlined",
                    rules: passwordRules,
                    "prepend-inner-icon": "mdi-lock",
                    "append-inner-icon": showNewPassword.value ? 'mdi-eye' : 'mdi-eye-off',
                    autofocus: "",
                    "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (showNewPassword.value = !showNewPassword.value)),
                    class: "mb-3"
                  }, null, 8, ["modelValue", "type", "append-inner-icon"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: confirmNewPassword.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmNewPassword).value = $event)),
                    label: "Yeni Şifre (Tekrar)",
                    type: showNewPassword.value ? 'text' : 'password',
                    variant: "outlined",
                    rules: confirmPasswordRules,
                    "prepend-inner-icon": "mdi-lock-check",
                    onKeyup: _withKeys(handleSubmit, ["enter"])
                  }, null, 8, ["modelValue", "type"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (resetError.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    variant: "tonal",
                    density: "compact",
                    class: "mt-2",
                    text: resetError.value
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "warning",
                variant: "flat",
                loading: resetting.value,
                disabled: !resetValid.value,
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-check",
                    class: "mr-1"
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode(" Şifreyi Kaydet ve Devam Et "))
                ]),
                _: 1,
                __: [6]
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})